import { styled, keyframes } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';
import theme from '../../../theme/theme';

const pulseAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const glowAnimation = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px rgba(74, 111, 232, 0.3),
                0 0 40px rgba(74, 111, 232, 0.2),
                0 0 60px rgba(74, 111, 232, 0.1);
  }
  50% {
    box-shadow: 0 0 30px rgba(74, 111, 232, 0.5),
                0 0 60px rgba(74, 111, 232, 0.3),
                0 0 90px rgba(74, 111, 232, 0.2);
  }
`;

export const Root = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100vh',
  background: 'transparent',
  zIndex: 9999,
});

export const LoadingContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '24px',
  padding: '40px',
});

export const CircleWrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  animation: `${pulseAnimation} 2s ease-in-out infinite`,
});

interface InnerCircleProps {
  size: number;
}

export const InnerCircle = styled(Box)<InnerCircleProps>(({ size }) => ({
  position: 'absolute',
  width: size * 0.7,
  height: size * 0.7,
  borderRadius: '50%',
  background: `linear-gradient(135deg,
    rgba(74, 111, 232, 0.15) 0%,
    rgba(74, 111, 232, 0.25) 100%)`,
  animation: `${glowAnimation} 2s ease-in-out infinite`,
  backdropFilter: 'blur(10px)',
}));

export const StyledCircularProgress = styled(CircularProgress)({
  color: theme.palette.primary.main,
  animation: `${rotateAnimation} 2s linear infinite`,
  '& .MuiCircularProgress-circle': {
    strokeLinecap: 'round',
    filter: 'drop-shadow(0 0 8px rgba(74, 111, 232, 0.5))',
  },
});

export const LoadingText = styled(Typography)({
  color: theme.palette.text.primary,
  fontWeight: 600,
  fontSize: '20px',
  textAlign: 'center',
  letterSpacing: '0.5px',
  marginTop: '8px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
});

export const SubText = styled(Typography)({
  color: theme.palette.text.secondary,
  fontSize: '14px',
  textAlign: 'center',
  fontWeight: 400,
  opacity: 0.8,
  [theme.breakpoints.down('sm')]: {
    fontSize: '13px',
  },
});
